import React from "react";
import { Route, Redirect } from "react-router-dom";
import { gbConstants } from "../_constants";

export const PrivateRoute = ({ component: Component, ...rest }) => {
    let user = JSON.parse(localStorage.getItem("user"));
    let isLoggedIn = user && user.token;

    return (
        <Route
            {...rest}
            render={props =>
                isLoggedIn ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: gbConstants.PATH_LOGIN,
                            state: { from: props.location }
                        }}
                    />
                )
            }
        />
    );
};



// WEBPACK FOOTER //
// ./src/_components/PrivateRoute.jsx